import { ensureRouteData } from '@/app/query-client'
import { postQueryOptions } from '@/features/posts/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { parsePostId } from '@/screens/posts/lib/parsePostId'

/**
 * The `/posts/$postId` loader. MAIN, awaited: the post itself, since the title row and the
 * article both come from it. `postQueryOptions` resolves `POST_NOT_FOUND` to `null`, so this only
 * throws the route to its error page for a genuine failure.
 *
 * A param that is not a post id returns at once without asking the network; `PostRoute` makes the
 * same check before it mounts the suspense-reading screen.
 */
export async function loadPost({
  context: { queryClient },
  params,
}: {
  context: RouterContext
  params: { postId: string }
}): Promise<void> {
  const postId = parsePostId(params.postId)
  if (postId === null) return
  await ensureRouteData(queryClient, postQueryOptions(postId))
}
